import React from 'react'
import Link from 'next/link'
import {useRouter} from 'next/router'

import Text from '@component/Text/Text'
import IconRight from '@svg/common/ic_btn_next.svg'
import {IBaseProps} from '@type/page'

interface IProps extends IBaseProps {
    linkClassName?: string
    link: string
    title: string
    rightIcon?: React.ReactNode
    onClick?: (e?: React.MouseEvent<HTMLAnchorElement>) => void
}

const MobileNavigationTitle: React.FC<IProps> = ({linkClassName, className, link, title, rightIcon, onClick}) => {
    const router = useRouter()
    const currentPath = router?.asPath
    const onClickLink = (e: React.MouseEvent<HTMLAnchorElement>) => {
        if (link === currentPath && e?.cancelable) {
            e?.preventDefault()
        } else {
            onClick?.(e)
        }
    }
    return (
        <Link href={link} onClick={onClickLink} className={linkClassName}>
            <div
                className={`flex items-center justify-between px-[20px] py-[15px] border-b border-gray07 dark:border-dark_gray07 ${className}`}>
                <div className={'flex items-center gap-x-[5px]'}>
                    <Text className={'text-ti1 text-gray01 dark:text-dark_gray01'}>{title}</Text>

                    {rightIcon}
                </div>
                <div className={'w-[14px] h-[14px]'}>
                    <IconRight className={'fill-gray01 dark:fill-dark_gray01'} />
                </div>
            </div>
        </Link>
    )
}
export default MobileNavigationTitle
